import { DashboardEnrollmentPresenter } from 'types/enrollmentService';
import { Group } from 'types/groupService';

export type DashboardGroupPresenter = Pick<
  Group,
  'id' | 'name' | 'agentOfRecord' | 'assigned' | 'source' | 'lastUpdateTime'
> & {
  enrollments: DashboardEnrollmentPresenter[];
};

export interface SelectedGroup {
  id: string;
  name: string;
}

export enum GroupAction {
  REMOVE = 'REMOVE',
  ARCHIVE = 'ARCHIVE',
}

export interface InboundLeadController {
  setGroupData(groupId: string, groupName: string): void;
}

export interface GroupInteractionController {
  commitGroupAction(groupAction: GroupAction, groupId: string, groupName: string): void;
}
